import styled, { css } from 'styled-components'

// Components
import UntypedTable from 'components/Table.old'
import { TableComponents } from 'components/Table'

//Utils
import { breakpoint } from 'utils'

import { ReactComponent as QuestionMarkIcon } from 'icons/question-mark-icon-17.svg'

// Styles
/*
  TODO: Use the correct types when this components update to Typescript
  https://github.com/sketch-hq/Cloud/issues/2190
*/
export const TableOld = UntypedTable as any

export const Wrapper = styled.div`
  margin-top: 20px;
`

export const LicenseKey = styled.span`
  color: ${({ theme }) => theme.colors.text.dark.primary};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`

export const CanceledButton = styled(TableOld.Button)`
  &,
  :hover,
  :focus,
  :active {
    color: ${({ theme }) => theme.colors.red};
  }
`

export const StateCell = styled(TableOld.Cell)``

const cellStyle = css`
  padding: 12px 4px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`

export const TableHeader = styled(TableOld.Header)`
  display: ${({ isVisible }) => (isVisible ? 'table-header-group' : 'none')};

  ${TableOld.HeaderCell} {
    ${cellStyle}
  }
`

export const TableRow = styled(TableOld.Row)`
  ${TableOld.Cell} {
    ${cellStyle}
  }

  ${breakpoint('base', 'sm')`
    display: flex;
    flex-direction: column;
    padding: 16px 0;

    ${StateCell} {
      margin-top: 8px;
    }

    ${TableOld.Cell} {
      padding: 0;
    }
  `}
`

export const QuestionMark = styled(QuestionMarkIcon)`
  width: 17px;
  height: 17px;
  opacity: 0.5;
`

export const TooltipWrapper = styled.div`
  display: inline-block;
`

export const TableWrapper = styled.div`
  ${TableComponents.Table} {
    width: 100%;
  }

  ${breakpoint('base', 'sm')`${css`
    ${TableComponents.TableHeader} {
      display: none;
    }

    ${TableComponents.TableRow} {
      display: flex;
      flex-direction: column;
      padding: 12px;
    }

    ${TableComponents.TableCell} {
      padding: 0;

      :nth-last-child(1) {
        margin-top: 8px;
      }
    }
  `}`}
`
